import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.payments_api.payment_coupons;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Wrap with cache
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'payments_api',
  group: 'payment_coupons',
  defaultTtl: '1m',
  hashLargeSegments: true,
  emitMeta: true,
});

export const getAllPaymentCoupons = async () => {
    return await retryWithBackoff(() =>
        cachedApi.get('/GetAllPaymentCoupons', undefined, { ttl: '2m' })
    );
}

export const getPaymentCouponById = async (paymentCouponId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetPaymentCouponById/${paymentCouponId}`, undefined, { ttl: '2m' })
    );
}

export const getPaymentCouponsByLocalId = async (localId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetPaymentCouponsByLocalId/${localId}`, undefined, { ttl: '2m' })
    );
}

export const getPaymentCouponsByMenuId = async (menuId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetPaymentCouponsByMenuId/${menuId}`, undefined, { ttl: '2m' })
    );
}

export const getPaymentCouponsByItemId = async (itemId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetPaymentCouponsByItemId/${itemId}`, undefined, { ttl: '2m' })
    );
}

export const createPaymentCoupon = async (paymentCouponData: any) => {
    const res = await retryWithBackoff(() =>
        api.post('/CreatePaymentCoupon', paymentCouponData)
    );
    await cachedApi.clear();
    return res;
}

export const updatePaymentCoupon = async (paymentCouponId: number, paymentCouponData: any) => {
    const res = await retryWithBackoff(() =>
        api.put(`/UpdatePaymentCoupon/${paymentCouponId}`, paymentCouponData)
    );
    await cachedApi.clear();
    return res;
}

export const updateExpirationDatePaymentCoupon = async (paymentCouponId: number, paymentCouponData: any) => {
    const res = await retryWithBackoff(() =>
        api.put(`/UpdateExpirationDatePaymentCoupon/${paymentCouponId}`, paymentCouponData)
    );
    await cachedApi.clear();
    return res;
}

export const deletePaymentCoupon = async (paymentCouponId: number) => {
    const res = await retryWithBackoff(() =>
        api.delete(`/DeletePaymentCoupon/${paymentCouponId}`)
    );
    await cachedApi.clear();
    return res;
}

